import { createContext as e } from "react";
var r = /* @__PURE__ */ e(void 0);
export {
  r as focusScope
};
